import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SigningJoinCodeResponse } from '../models/signing-join-code.model';

interface ClearSignRedirectUrlResponse {
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class SigningJoinCodeService {
  private readonly http = inject(HttpClient);

  resolve(joinCode: string): Observable<SigningJoinCodeResponse> {
    return this.http.get<SigningJoinCodeResponse>(
      `/api/v1/signing-join-codes/${joinCode}`,
    );
  }

  getClearSignRedirectUrl(joinCode: string): Observable<ClearSignRedirectUrlResponse> {
    return this.http.get<ClearSignRedirectUrlResponse>(
      `/api/v1/signing-join-codes/${joinCode}/clearsign-url`,
    );
  }
}
